export default __webpack_public_path__ + "img/avatar-ac55a425.png";